//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Die.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../no/SelectNXObjectList.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/SelectObjectList.js";
let d=[[[0,"Associative",1,0],[1,"ConcaveCornerRadius",0,"Expression",0],[0,"DistanceTolerance",1,0],[0,"Limits",0,"Die.DieLimitsBuilder",0],[0,"Method",1,0],[0,"RefPoint",1,"Point",0],[1,"SelectSection",0,"SelectNXObjectList",0],[0,"Sewn",1,0],[1,"Spine",0,"ScCollector",0],[0,"SpineRadius",1,0],[1,"TrimBound",0,"ScCollector",0]],[[[],"CreateDefaultSpine",{},0,0]],[]];
SPLM.Die.AddSurfBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Die.AddSurfBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Die.AddSurfBuilder.Methods = Object.freeze({
    "Sectional" : "Sectional", "CurveMesh" : "CurveMesh", "ChannelTunnelCap" : "ChannelTunnelCap", "MultiFaceBlend" : "MultiFaceBlend", "WallsOnly" : "WallsOnly", "DiskFaceBlend" : "DiskFaceBlend", "SphereFaceBlend" : "SphereFaceBlend"});

export default SPLM;